interface PageMenuTitleProps {
  menu: string;
  description?: string;
  className?: string;
}

export const PageMenuTitle: React.FC<PageMenuTitleProps> = ({
  menu,
  description,
  className = "",
}) => {
  const renderDescription = () => {
    if (!description) return null;

    // \n 기준으로 줄바꿈
    return description.split("\n").map((line, i) => (
      <span key={i}>
        {line}
        {i < description.split("\n").length - 1 && <br />}
      </span>
    ));
  };

  return (
    <div className={` ${className}`}>
      <h2
        className="lg:text-2xl lg:leading-9 md:text-xl md:leading-8 text-base leading-7 tracking-tight text-[#347E82]"
        style={{ fontFamily: '"pre-SemiBold", sans-serif' }}
      >
        {menu}
      </h2>
      {description && (
        <p
          className="text-xl leading-7 md:text-4xl md:leading-12 xl:text-6xl tracking-tight xl:leading-18  text-black-almostBlack mt-6 md:mt-8 lg:mt-12"
          style={{ fontFamily: '"pre-Bold", sans-serif' }}
        >
          {renderDescription()}
        </p>
      )}
    </div>
  );
};
